// #268's sign-out half, Session 296 — ONE SENTENCE FOR "NOT LET IN", whichever
// check refuses.
//
// A deactivated person used to be turned away by the app's own gate, after a
// sign-in Supabase had accepted: Login says the sentence below (#268's gate
// deliberately does not say which reason applied). Their sign-in is now also
// LOCKED at Supabase (functions/set-user-active.js), and an archived person's
// has been since #381 — so Supabase refuses first, in its own words, "User is
// banned". That told the person something different from the gate, and told
// whoever was typing that the password had been right.
//
// So a locked sign-in reads exactly as the gate's refusal does.

export const NO_ACCESS_SENTENCE =
  "This account doesn't have access to Stede. Contact your system administrator.";

// #268, Session 297 — THE DATABASE REFUSES A DEACTIVATED PERSON AT ONCE NOW, ahead
// of every request (db/migrations/20261031_deactivated_refused_268.sql), with this
// code of Stede's own. A read refused this way is an answer, not a failed read: the
// person is deactivated. Anything else that goes wrong stays what it was, because
// one network blip must not sign the whole company out (#268's decision 2).
export const INACTIVE_REFUSAL_CODE = 'STEDE_INACTIVE';

export function isInactiveRefusal(error) {
  return !!error && error.code === INACTIVE_REFUSAL_CODE;
}

// The sentence for a failed sign-in: the gate's, when Supabase refused a locked
// account; otherwise Supabase's own message, as before.
export function signInErrorSentence(error) {
  if (!error) return '';
  if (error.code === 'user_banned' || /\bbanned\b/i.test(error.message || '')) {
    return NO_ACCESS_SENTENCE;
  }
  return error.message;
}
